import ChargingSessionListPresenter from "./ChargingSessionList/ChargingSessionListPresenter/ChargingSessionListPresenter";


export const ChargingSessionList = {
    List : ChargingSessionListPresenter
}

export default ChargingSessionList;